import { Container } from 'theme-ui';
import { useBlog } from '@backpackjs/storefront';

import { BlogNav } from './BlogNav/BlogNav';

export function BlogTemplate({ renderSections }) {
  const blog = useBlog();

  return (
    <Container data-comp="BlogTemplate">
      <BlogNav blogHandle={blog?.handle} articlePage={false} />
      {renderSections()}
    </Container>
  );
}
